import * as React from "react";
const SvgShare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 6L12 2L16 6", stroke: "#737373", style: {
  stroke: "#737373",
  stroke: "color(display-p3 0.4510 0.4510 0.4510)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 3V13", stroke: "#737373", style: {
  stroke: "#737373",
  stroke: "color(display-p3 0.4510 0.4510 0.4510)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17 10C18.1046 10 19 10.8954 19 12V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V12C5 10.8954 5.89543 10 7 10", stroke: "#737373", style: {
  stroke: "#737373",
  stroke: "color(display-p3 0.4510 0.4510 0.4510)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgShare;
